import React from 'react';
import { useDispatch } from 'react-redux';
import { playCard } from '../../../redux/actions/socketActions';

import './card.scss';
function CardItem({ id, suit, handActive, disabled, card, downCard }) {
	const dispatch = useDispatch();

	return (
		<div
			onClick={() => {
				if (downCard) return;
				if (handActive === 0) return;
				// console.log(disabled);
				if (!disabled) {
					dispatch(playCard({ suit, card }));
					//   dispatch({ type: "THROW_CARD", id, show: true, suit, card });
					//   dispatch({ type: "HAND_ACTIVE", value: 0 });
				}
			}}
		>
			<div
				className={`card ${downCard} ${disabled ? 'grayscale' : ''}`}
				data-card={`${card} ${suit}`}
				data-disabled={disabled ? disabled : ''}
			></div>
		</div>
	);
}
export default CardItem;
